import "./styles.css";
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleDown,
  faChevronCircleUp,
} from "@fortawesome/free-solid-svg-icons";

export const Menu = forwardRef(({ pesquisado, handleMenuSelection, tipo, origem, page, disabled }, ref) => {
  const [activeTipoId, setActiveTipoId] = useState(null);
  const [activeOrigemId, setActiveOrigemId] = useState(null);
  const [menuItems, setMenuItems] = useState({});
  const [loading, setLoading] = useState(true);

  const handleItemClick = (itemName) => {
    setMenuItems((prevState) => ({
      ...prevState,
      [itemName]: prevState[itemName] === "aberto" ? "" : "aberto",
    }));

    // Ativar/desativar apenas o item clicado
    setActiveTipoId(itemName === "procuradoriaGeral" ? activeTipoId : null);
    Object.keys(menuItems).forEach((key) => {
      if (key !== itemName) {
        setMenuItems((prevState) => ({
          ...prevState,
          [key]: "",
        }));
      }
    });
  };

  const apiUrl2 = `${process.env.REACT_APP_API_BASE_URL}/listar-origens`;
  const [origens, SetOrigens] = useState([]);

  useEffect(() => {
    fetch(apiUrl2)
      .then((response) => response.json())
      .then((responseData) => {
        SetOrigens(responseData);
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false); // Marca o carregamento como concluído
      });
  }, []);

  const [tiposPorOrigens, SetTiposPorOrigens] = useState([]);

  useEffect(() => {
    origens.forEach((origem) => {
      const apiUrl3 = `${process.env.REACT_APP_API_BASE_URL}/listar-tipos-por-origem/${origem.id}`;
      fetch(apiUrl3)
        .then((response) => response.json())
        .then((responseData) => {
          SetTiposPorOrigens((prevState) => ({
            ...prevState,
            [origem.id]: responseData,
          }));
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
        });
    });
  }, [origens]);

  const renderArrow = (isOpen) => {
    return isOpen ? (
      <FontAwesomeIcon icon={faChevronCircleUp} className="arrow-up" />
    ) : (
      <FontAwesomeIcon icon={faChevronCircleDown} className="arrow-down" />
    );
  };

  // Expose clearActiveMenuItem method to parent component
  useImperativeHandle(ref, () => ({
    setActiveMenuItens(origemId, tipoId) {
      setActiveTipoId(tipoId);
      setActiveOrigemId(origemId);
      console.log("twioerjower: " + origemId + " werwjoerjow: " + tipoId);
    }
  }));

  return (
    <div className="sidebar">
      <div className="menu-sidebar">
        <ul id="multisidetabs" className="nav navbar-nav list-group">
          <li className="menu-item">
            {loading ? (
              <p className="Spinner"></p> // Mensagem de carregamento
            ) : (
              <ul className={`sub-menu Inical`}>
                {origens.map((item2) => (
                  <li
                    className={`menu-item ${disabled ? "disabled" : ""}`}
                    key={item2.id}
                  >
                    <a
                      onClick={() => [
                        handleItemClick(item2.nome),
                        tipo(-1),
                        origem(`${item2.id}`),
                        page(1),
                        handleMenuSelection(item2.nome, ""),
                        setActiveOrigemId(item2.id),
                        setActiveTipoId(null),
                      ]}
                      className={`btnPai ${menuItems[item2.nome]} ${item2.id === activeOrigemId ? "ativo" : ""
                        }`}
                    >
                      {item2.nome}
                      {item2.descricao}
                      {renderArrow(menuItems[item2.nome] === "aberto")}
                    </a>
                    <ul className={`sub-menu ${menuItems[item2.nome]}`}>
                      {tiposPorOrigens[item2.id]?.map((item) => (
                        <li className="menu-item" key={item.id}>
                          <a
                            onClick={(e) => [
                              pesquisado(`${item.descricao}`),
                              handleMenuSelection(item2.nome, item.descricao),
                              tipo(`${item.id}`),
                              origem(`${item2.id}`),
                              page(1),
                              setActiveTipoId(item.id),
                              setActiveOrigemId(null),
                            ]}
                            className={`btnPai ${item.id === activeTipoId ? "ativo" : ""
                              }`}
                          >
                            {item.descricao}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
});
